// extracted by mini-css-extract-plugin
export default {"project_container":"ProjectSection_project_container__2f+6Q","project_cards":"ProjectSection_project_cards__70X4J"};